import React, { VFC } from "react";
import HelpfulButton from "~/components/atoms/ShareButton/HelpfulButton";
import LineButton from "~/components/atoms/ShareButton/LineButton";
import TwitterButton from "~/components/atoms/ShareButton/TwitterButton";

interface Props {
  helpfulCount: number;
}

const PreviewShareAction: VFC<Props> = ({ helpfulCount }) => {
  const onSNSIconClick = () => {
    alert("ユーザー向けページでのみ動作します");
  };
  return (
    <>
      <HelpfulButton
        iconType="outline"
        onClick={onSNSIconClick}
        size="medium"
        // show dummy number of like in preview
        label={helpfulCount > 999 ? "999+" : helpfulCount.toString()}
      />
      <TwitterButton onClick={onSNSIconClick} size="medium" />
      <LineButton onClick={onSNSIconClick} size="medium" />
    </>
  );
};

export default PreviewShareAction;
